import PropTypes from 'prop-types';
import React from 'react';
import LinkGroup from '../../../components/LinkGroup';
import {LinkShape} from '../../../utils/react/Shapes';
import {intlShape} from 'react-intl';

class UserManagementList extends React.Component {

  static propTypes = {
    links: PropTypes.arrayOf(LinkShape),
    clickHandler: PropTypes.func.isRequired
  };
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    intl: intlShape
  };

  static async loadAction() {
    console.log('Loading user management list');
  }

  render() {

    return (
      <div className='user-management-list flex-element' onClick={this.props.clickHandler}>
        <LinkGroup links={ this.props.links } showFavorite={false}/>
      </div>
    );
  }
}

export default UserManagementList;



// WEBPACK FOOTER //
// ./src/apps/UserManagement/components/UserManagementList.js